"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrivateContext = exports.getDashboardContext = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
/**
 * Gets the public dashboard context stored inside redux-saga context.
 */
function getDashboardContext() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.getContext("dashboardContext")];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
exports.getDashboardContext = getDashboardContext;
/**
 * Gets the private dashboard context stored inside redux-saga context.
 */
function getPrivateContext() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.getContext("privateContext")];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
exports.getPrivateContext = getPrivateContext;
//# sourceMappingURL=contexts.js.map